import { useContext } from "react";
import { LocationOutlinedIcon } from "shared-components/Components/CustomIcons/LocationOutlineIcon/web";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { getOptionLabel } from "src/utils/Functions";
import { SearchIcon } from "shared-components/Components/CustomIcons/SearchIcon/web";
import HouseIcon from "shared-components/Components/CustomIcons/HouseIcon/web";

interface RecientLocationsProps {
  recientLocations: Array<{
    type: 'location' | 'keyword' | 'reference';
    [key: string]: any;
  }>;
  handleSelectLocation: (location: any) => void;
  handleSelectKeyword: (keyword: string) => void;
  handleSelectReference: (reference: any) => void;
}

export const RecientLocations = ({
  recientLocations,
  handleSelectLocation,
  handleSelectKeyword,
  handleSelectReference
}: RecientLocationsProps) => {
  const { translations } = useContext(ConfigStateContext);

  const KeywordItem = ({ item }) => (
    <li 
      className="option"
      onClick={() => handleSelectKeyword(item.name)}
      onTouchEnd={() => handleSelectKeyword(item.name)}
    >
      <span className="location-icon"><SearchIcon width={20} /></span>
      
      <span className="location-text">
        <span className="text">{item.name}</span>
        <span className="group">Palabra clave</span>
      </span>
    </li>
  );

  const LocationItem = ({ item }) => {
    const label = getOptionLabel(item);
    const group = translations[item.type.toLowerCase()];

    return (
      <li 
        className="option"
        onClick={(e) => handleSelectLocation(item)}
        onTouchEnd={() => handleSelectLocation(item)}
      >
        <span className="location-icon"><LocationOutlinedIcon width={20} /></span>
        
        <span className="location-text">
          <span className="text" dangerouslySetInnerHTML={{__html: label}}></span>
          <span className="group">{group}</span>
        </span>
      </li>
    );
  };

  const ReferenceItem = ({ item }) => (
    <li 
      className="option"
      onClick={() => handleSelectReference(item)}
      onTouchEnd={() => handleSelectReference(item)}
    >
      <span className="location-icon"><HouseIcon width={20} /></span>
      
      <span className="location-text">
        <span className="text">{item.title}</span>
        <span className="group">{item.property_type?.name || 'Referencia'}</span>
      </span>
    </li>
  );

  return (
    <ul className="option-list">
      <h5 className="option-list--title">Recientes</h5>

      {recientLocations.map((option, i) => {
        if (option.type === "keyword") {
          return <KeywordItem item={option} key={`${i}-${option.name}`} />;
        } else if (option.type === "reference") {
          return <ReferenceItem item={option} key={`${i}-${option.code}`} />;
        } else {
          return <LocationItem item={option} key={`${i}-${option.id}`} />;
        }
      })}
    </ul>
  );
};